var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.events.length)?_c('v-sparkline',{staticStyle:{"width":"60px","height":"8.25px"},attrs:{"value":_vm.events,"line-width":"16","padding":"16","height":"55","width":"400","color":_vm.item.indicator && _vm.item.indicator.color ? _vm.item.indicator.color : 'black'}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }